export default {
	'asset linked to risks': 'See vara on otse seotud riskidega. Eemaldage või määrake need ümber enne vara kustutamist.',
	'login failed': 'Sisselogimine ebaõnnestus',
	'invalid password': 'Vigane parool',
	'not unique user:': 'Kasutaja ei ole unikaalne',
	'invalid email': 'Vigane e-mail',
	'not unique email': 'E-mail ei ole unikaalne',
	'invalid idCode': 'Vigane isikukood',
	'not unique idCode': 'Isikukood ei ole unikaalne',
	'not unique adUser': 'AD kasutajanimi ei ole unikaalne',
	'audit name': 'Auditi nimi on ebasobilik',
	'audit name exists': 'Sama nimega audit on juba olemas',
	'auditor level': 'Õigus auditeerida puudub',
	'domain start': 'Domeeni nimi peab algama "https://"-ga',
	'domain end': 'Domeen peab lõppema "/"-ga',
	'domain required': 'Domeen on kohustuslik väli',
	'admin required': 'Administaator on kohustuslik väli',
	'instance required': 'Asutus on kohustuslik väli',
	'invalid email format': 'Vale emaili formaat',
	path: 'Ebasobilik viide',
	'api token length': 'API token peab olema pikem kui 10 tähemärki',
	'instance ID does not match': 'Asutuse ID ei ühti hetkel aktiivse asutuse ID-ga või ei ole peaasutus',
	'admin ID does not match': 'Administaatori ID ei ühti hetkel aktiivse kasutaja ID-ga või ei ole peakasutaja',
	'email should not be empty': 'Emaili väli ei tohi olla tühi, kui on aktiivne domeeni konfiguratsioon',
	'one active per instance': 'Ainult üks domeeni konfiguratsioon võib olla asutusel korraga aktiivne',
	'None of the methods have a domain configuration for exporting':
		'Ühelgi valitud meetmel ei ole olemas domeeni konfiguratsiooni eksportimise jaoks.',
	'Could not find a domain config for instance': 'Asutuse jaoks ei leitud domeeni konfiguratsiooni.',
	'401 Unauthorized Client must be authenticated to access this resource request failed Please analyze the request body for more details Status code 401':
		'Klient peab olema autenditud, et saada ligipääs Jirale.',
	'Could not find a domain configuration for instance': 'Asutuse jaoks ei leitud domeeni konfiguratsiooni.',
	'Information is missing for domain configuration': 'Domeeni konfiguratsiooni informatsioon on puudulik.',
	'You must have global administrator rights in order to modify projects': 'Projekti loomiseks on vajalik administraatori õigused.',
	'You do not have permission to create issues in this project': 'Teil pole õiguseid, et luua ülesandeid selles Jira projektis.',
	'There was an error with issue creation': 'Jira ülesannete loomisel tekkis viga.',
	'Rule exporting failed': 'Reegli eksportimisel tekkis viga.',
	'could not delete chosen domain config': 'Valitud domeeni konfiguratsiooni ei olnud võimalik kustutada.',
	fieldCannotBeSet: "Väljaga '{fieldName}' on tekkinud viga. Väljal võivad puududa õigused või on valesti seadistatud.",
	'The value "EITS" does not exist for the field "project" request failed Please analyze the request body for more details Status code 400':
		'Projekti "EITS" loomisel tekkis viga. Kasutajal võib puududa õigused või projekt juba eksisteerib.',
	'Could not find issue by id or key': 'Polnud võimalik leida Jira ülesannet ID või võtme abil.',
	'No issue data was provided by request': 'Jira ülesandel puuduvad andmed.',
	'A project with that name already exists': 'Projekt nimega EITS juba eksisteerib. Kontrollige vajadusel ka Jira projektide prügikasti.',
	'Module exporting failed': 'Mooduli eksportimisel tekkis viga.',
	'The request has been rate-limited Please try again later': 'Taotlus on piiratud määraga. Proovige hiljem uuesti.',
	'Specify an issue type': 'Ülesande tüüp puudub. Palun vaadake üle, kas "Task", "Epic", "Sub-Task" eksisteerivad.',
	'Issue does not exist or you do not have permission to see it request failed Please analyze the request body for more details Status code 400':
		'Ülesanne ei eksisteeri või puudub õigus seda näha. Ülesanne võib eksisteerida andmebaasis, kuid mitte enam Jiras.',
	'An error occurred comatlassianidpclientexceptionsAuthorizationException "key""forbidden""context""message""Not admin"':
		'Autentimise viga: Teil puudub administraatori õigused. ',
	'a role with the same name already exists': 'Roll selle nimega juba eksisteerib!',
	'Request failed with status code 413': 'Error: Faili suurus on liiga suur!',
	'not found': 'Ei leitud',
	'permission denied': 'Puudub õigus',
	'instance denied': 'Keelatud asutus',
	'file exists': 'Faili nimi on juba olemas',
}
